import { compose } from 'recompose';

// Import components
import ClauseRow from "./ClauseRow";
var enhancer = compose();
export default enhancer(ClauseRow);